import React from 'react'
import { Container, Stack } from '@chakra-ui/react'
import SuggestedProducts from './sugested-products'
import Detail from './detail'
import { ProductProvider } from '@lib/context/product-context'
import SkeletonDetail from '@components/skeleton/skeleton-detail'
import BodyLayout from '@layouts/body-layout'
import VideoProduct from './video-product'
import Reviews from './reviews'
import ProductTabDetailFAQ from './product-tab-detail-faq'
import { useResponsive } from '@common/hooks'
import { useProduct } from 'medusa-react'
import { IProduct } from '@common/interface/product'

interface PropsType {
  product: IProduct
  isLoading: boolean
}

const ProductShopDetail = ({ product, isLoading }: PropsType) => {
  const { mdMax } = useResponsive()

  const { product: p } = useProduct(product.id)

  return (
    <Container>
      <Stack my={mdMax ? 0 : 16}>
        <BodyLayout gap={20}>
          {isLoading && <SkeletonDetail />}
          {product && (
            <ProductProvider product={product}>
              <Detail item={product} />
            </ProductProvider>
          )}
          {product && (
            <VideoProduct
              links={
                product.images
                  .filter((i: any) => i?.media_type === 'video')
                  .map((i: any) => i?.url || '') || []
              }
            />
          )}
          {product && (
            <ProductTabDetailFAQ detail={product.detail} faq={product.faq} />
          )}
          {product && <Reviews productId={product.id} />}
          {product && (
            <SuggestedProducts
              categories={p?.categories ?? []}
              collections={product.collection ? [product.collection] : []}
              productId={product.id}
            />
          )}
        </BodyLayout>
      </Stack>
    </Container>
  )
}

export default ProductShopDetail
